import {
  PatientBasicsDto,
  TracingContactDetailsDtoAssessmentStatus,
  TracingContactSummaryDto,
} from '../../api/generated/model';
import { TracingContactTableFilter } from '../../state/tracingContactSearchAtoms.ts';
import { getLatestAppointment } from '../appointment.ts';

export function getTracingContactTableFilterName(tableFilter: TracingContactTableFilter) {
  switch (tableFilter) {
    case TracingContactTableFilter.ALL:
      return 'Alle';
    case TracingContactTableFilter.PENDING:
      return 'Einschätzung nötig';
    case TracingContactTableFilter.APPOINTMENT_ARRANGED:
      return 'Termin';
    case TracingContactTableFilter.NO_UU_NEEDED:
      return 'Keine UU nötig';
    case TracingContactTableFilter.TEST_EXECUTED:
      return 'Test durchgeführt';
    case TracingContactTableFilter.WAITING_PERIOD:
      return 'Wartefrist';
  }
}

export function filterTracingContacts(
  tracingContacts: TracingContactSummaryDto[],
  tableFilter: TracingContactTableFilter,
  selectedPatient: PatientBasicsDto | null,
) {
  const contactsForPatient = selectedPatient
    ? tracingContacts.filter((contact) => contact.contactPatientId === selectedPatient.id)
    : tracingContacts;

  switch (tableFilter) {
    case TracingContactTableFilter.ALL:
      return contactsForPatient;
    case TracingContactTableFilter.PENDING:
      return contactsForPatient.filter(
        (contact) =>
          contact.tracingContactDetails.assessmentStatus === TracingContactDetailsDtoAssessmentStatus.PENDING,
      );
    case TracingContactTableFilter.APPOINTMENT_ARRANGED:
      return contactsForPatient.filter((contact) => appointmentFilterCondition(contact));
    case TracingContactTableFilter.NO_UU_NEEDED:
      return contactsForPatient.filter(
        (contact) =>
          contact.tracingContactDetails.assessmentStatus === TracingContactDetailsDtoAssessmentStatus.NO_UU_NEEDED,
      );
    case TracingContactTableFilter.TEST_EXECUTED:
      return contactsForPatient.filter((contact) => textExecutedFilterCondition(contact));
    case TracingContactTableFilter.WAITING_PERIOD:
      return contactsForPatient.filter(
        (contact) =>
          contact.tracingContactDetails.assessmentStatus === TracingContactDetailsDtoAssessmentStatus.WAITING_PERIOD,
      );
  }
}

function appointmentFilterCondition(contact: TracingContactSummaryDto) {
  if (contact.tracingContactDetails.assessmentStatus !== TracingContactDetailsDtoAssessmentStatus.APPOINTMENT_VISIT)
    return false;

  const latestAppointment = getLatestAppointment(contact.appointments);

  return !contact.labOrders.find((order) => order.appointmentId === latestAppointment?.id);
}

function textExecutedFilterCondition(contact: TracingContactSummaryDto) {
  if (contact.tracingContactDetails.assessmentStatus !== TracingContactDetailsDtoAssessmentStatus.APPOINTMENT_VISIT)
    return false;

  const latestAppointment = getLatestAppointment(contact.appointments);

  return !!contact.labOrders.find((order) => order.appointmentId === latestAppointment?.id);
}
